import Vue from 'vue'
import App from '../App.vue'
import router from '../modules/router/router.js'
import { i18n } from '../modules/i18n-setup/i18n-setup.js'
import Axios from 'axios'
import VueMq from 'vue-mq'
import { store } from '../store/index.js'
import { constructDataForPost } from '../modules/global.js'
import PageNames from '../constant/pageNames.js'

import {
  BButton,
  ModalPlugin,
} from 'bootstrap-vue'
import { NOTY_TYPE } from '../constant/builderConsts.js'

/* components */
Vue.component('b-btn', BButton)

Vue.use(ModalPlugin)
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    megaMenuLarge: 1800,
    xxl: Infinity,
  },
  defaultBreakpoint: 'lg', // customize this for SSR
})
// vue-ból kapott hibák is menjenek az errbitbe
Vue.config.errorHandler = (error, vm, info) => {
  window.sendWarning(error, {
    info,
  })
}

Vue.mixin({
  data() {
    return {
      /**
       * 404 page mutatása
       */
      showNotFoundPage: false,
    }
  },
  methods: {
    /**
     * Post-hoz formdata előállítása global method
     *
     * @param object
     * @returns {FormData}
     */
    constructDataForPost: function (object) {
      return constructDataForPost(object)
    },
    /**
     * fordítás lekérése paraméterek cseréjével
     *
     * pl a kulcsra: "teszt.nyelvi.kulcs": "test {{text}} tesztelés",
     * pl: this.translateWithMarkers('teszt.nyelvi.kulcs', { text: 'szöveg' })
     *
     * @param translateKey
     * @param markers
     * @return string
     */
    translateWithMarkers(translateKey, markers) {
      let translation = this.$t(translateKey)
      Object.keys(markers).forEach(markerKey => {
        translation = translation.replace('{{' + markerKey + '}}', markers[markerKey])
      })
      return translation
    },
    /**
     * meta tag tartalmát változtatjuk
     */
    changeMetaTagContent(tagName, content) {
      // title speciális
      if (tagName === 'title') {
        document.title = content
        return
      }
      const nameTagList = [
        'description',
        'keywords',
        'robots',
        'viewport',
      ]
      const relTagList = [
        'canonical',
      ]
      let nameOrProperty = ''
      if (relTagList.includes(tagName)) {
        nameOrProperty = 'rel'
      } else if (nameTagList.includes(tagName)) {
        nameOrProperty = 'name'
      } else {
        nameOrProperty = 'property'
      }
      let metaTag = document.querySelector('meta[' + nameOrProperty + '="' + tagName + '"]')
      if (!metaTag) {
        metaTag = document.createElement('meta')
        metaTag[nameOrProperty] = tagName
        metaTag.content = content
        document.head.appendChild(metaTag)
      } else {
        if (content && content !== '') {
          metaTag.setAttribute('content', content)
        } else {
          metaTag.remove()
        }
      }
    },
    getIsShowingNotFoundPage() {
      return this.showNotFoundPage
    },
    setShowNotFoundPage(showNotFoundPage) {
      this.showNotFoundPage = showNotFoundPage
    },
    /**
     * kosár változáskor futtatandó emarsys event
     */
    emarsysCartChangedEvent() {
      Axios.get('/Shop/api/emarsysCartChangedEvent')
        .then(({ data }) => {
          window.addEmarsys(data)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    /**
     * Vásárláskor lefutó esemény, ami a Klaviyo API hívást intézi a háttérben
     */
    /* Egyelőre a placeOrder függvény küldi API-n kereszül! Ha lassú lesz, akkor jön ez a megoldás
    klaviyoPurchaseEvent() {
      if (!window.isKlaviyoEnabled) {
        return
      }

      Axios.get('/Shop/api/klaviyoPurchaseEvent')
        .then(({ data }) => {
          window.addEmarsys(data)
        })
        .catch((error) => {
          console.error(error)
        })
    }*/
  },
})

export default new Vue({
  el: '#app',
  components: {
    App,
  },
  router,
  i18n,
  store,
  created() {
    // vue init után betöltjük a site és user adatokat a storeba
    this.$store.dispatch('Site/init')
    const vm = this
    Axios.interceptors.request.use(
      (request) => {
        // eslint-disable-next-line no-param-reassign
        request.headers.buildVersion = __VERSION__
        return Promise.resolve(request)
      },
      (error) => {
        return Promise.reject(error)
      })
    Axios.interceptors.response.use(
      (response) => {
        if (typeof response.data !== 'object') {
          return Promise.resolve(response)
        }
        // ha php-ban használtuk ajax a redir 404 vagy hasonlot, akkor ez fogja megoldani
        if ('redirectToUrl' in response.data) {
          if (response.data.isVueRedirect) {
            vm.$router.push(response.data.redirectToUrl)
          } else {
            window.location.href = response.data.redirectToUrl
          }
        } else if ('pageNotFound' in response.data && response.data.pageNotFound) {
          vm.$root.$emit('showNotFoundPage')
        } else if ('needCartHeaderReload' in response.data && response.data.needCartHeaderReload) {
          vm.$store.dispatch('Cart/resetDataLoadedFlags')
          vm.$store.dispatch('Cart/getBasicCheckoutData', true)
          vm.$store.dispatch('Cart/getCartEditData', true)
          vm.$store.dispatch('Cart/getCartAddressData', true)
        }
        return Promise.resolve(response)
      },
      (error) => {
        // ha 403 kódú responset adtunk vissza, akkor a usernek lejárt a session-je
        if (error.response.status === 403) {
          // kérjük lépjen be üzenet
          vm.$root.$emit('notificationPush', vm.$t('bejelentkezes_kerese'), NOTY_TYPE.NOTY_WARNING)
          // user adatok frissitése (ilyenkor, arra hogy nincs)
          vm.$store.dispatch('User/refreshActiveUser')
            .then(() => {
              // át navigáljuk a loginra
              vm.$router.push({ name: PageNames.PAGE_LOGIN })
            })
        }
        // Do something with response error
        return Promise.reject(error)
      },
    )
  },
})
